import { xcSelectors } from '@cmg/e2e-selectors';

import { OfferingSetupStepId } from '../offering-setup-next/components/OfferingSetupNav';

/**
 * Represents the steps in the wizard, as represented in the UI.
 *
 * ORDER MATTERS!!!
 */
export const stepIds = {
  BASIC_INFO: 'info',
  PRIVATE_TERMS: 'private-terms',
  CURRENCIES: 'currencies',
  INSTRUMENTS: 'instruments',
  TRANCHES: 'tranches',
  MANAGERS: 'managers',
  TIMING: 'timing',
  MARKETING: 'marketing',
  OFFERING_TERMS: 'offering-terms',
  ORDER_BOOK_CONFIGURATION: 'order-book-configuration',
  UNDERWRITING_TERMS: 'underwriting-terms',
  DOCUMENTATION: 'documentation',
  DISCLAIMERS: 'disclaimers',
  SUMMARY: 'summary',
};

type Steps = Required<keyof typeof stepIds & OfferingSetupStepId>;

export const stepTitles: Record<Steps, string> = {
  [stepIds.BASIC_INFO]: 'Issuer Details',
  [stepIds.PRIVATE_TERMS]: 'Offering Terms',
  [stepIds.CURRENCIES]: 'Currencies',
  [stepIds.INSTRUMENTS]: 'Instruments',
  [stepIds.TRANCHES]: 'Tranches',
  [stepIds.MANAGERS]: 'Managers',
  [stepIds.TIMING]: 'Timing',
  [stepIds.MARKETING]: 'Marketing',
  [stepIds.OFFERING_TERMS]: 'Offering Terms',
  [stepIds.ORDER_BOOK_CONFIGURATION]: 'Order Book Config.',
  [stepIds.UNDERWRITING_TERMS]: 'Underwriting Terms',
  [stepIds.DOCUMENTATION]: 'Documentation',
  [stepIds.DISCLAIMERS]: 'Disclaimers',
  [stepIds.SUMMARY]: 'Summary',
  /**
   * This is a special case for new pricing route used in offering-setup-next
   */
  pricing: 'Instrument, Currency, Tranche',
};

export const stepDataTestIds = {
  [stepIds.BASIC_INFO]: xcSelectors.offeringSetupSideNavBasicInfo.testId,
  [stepIds.CURRENCIES]: xcSelectors.offeringSetupSideNavCurrencies.testId,
  [stepIds.INSTRUMENTS]: xcSelectors.offeringSetupSideNavInstruments.testId,
  [stepIds.TRANCHES]: xcSelectors.offeringSetupSideNavTranches.testId,
  [stepIds.MANAGERS]: xcSelectors.offeringSetupSideNavManagers.testId,
  [stepIds.TIMING]: xcSelectors.offeringSetupSideNavTiming.testId,
  [stepIds.MARKETING]: xcSelectors.offeringSetupSideNavMarketing.testId,
  [stepIds.DISCLAIMERS]: xcSelectors.offeringSetupSideNavDisclaimers.testId,
  [stepIds.SUMMARY]: xcSelectors.offeringSetupSideNavSummary.testId,
};
